/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import styled from 'styled-components/native';
// import { getScaledValue } from 'renative';

import { getScaledValue } from '../../../ui/styled';

export const UserProfileContent = styled.TouchableOpacity.attrs({})``;

export const UserProfile = styled.ImageBackground.attrs({})`
  width: ${getScaledValue(42)}px;
  height: ${getScaledValue(42)}px;
  background: ${(props: { focused?: boolean; theme: { primary: string } }) =>
    props.theme.primary || 'rgba(255,255,255,.1)'};
  border-radius: ${getScaledValue(21)}px;
  border-width: ${getScaledValue(3)}px;
  ${(props: { focused?: boolean; theme: { primary: string } }) =>
    props.focused
      ? `
            border-color: ${props.theme.primary || 'rgba(255,255,255,.1)'};
        `
      : `
            border-color: rgba(255,255,255,.1);
        `}
  overflow: hidden;
`;
